import SyncGroupList from "./SyncGroupList";

const SyncHistoryList = () => <SyncGroupList history />;

export default SyncHistoryList;
